type Props = { fill?: string };

const ServiceIcon = ({ fill }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_11728_191821)">
        <path
          d="M15 1H12V3H14V14H2V3H4V1H1C0.4 1 0 1.4 0 2V15C0 15.6 0.4 16 1 16H15C15.6 16 16 15.6 16 15V2C16 1.4 15.6 1 15 1Z"
          fill="#3B3F42"
        />
        <path d="M11 0H5V4H11V0Z" fill="#3B3F42" />
        <path d="M12 6H4V8H12V6Z" fill="#3B3F42" />
        <path d="M12 10H4V12H12V10Z" fill="#3B3F42" />
      </g>
      <defs>
        <clipPath id="clip0_11728_191821">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ServiceIcon;
